export const firebaseConfig = {
    apiKey: "AIzaSyCIF1_dbZ3UHMe1x3Fxtu-GB0mYwzrh5Mo",
    authDomain: "edgen-396119.firebaseapp.com",
    projectId: "edgen-396119",
    storageBucket: "edgen-396119.appspot.com",
    messagingSenderId: "24981225358",
    appId: "1:24981225358:web:8d25824e0337c6ea8caedf",
    measurementId: "G-5C6JLFCYD2"
};

